'use strict';

// Tracker should be loaded via CDN prior to using this module.

if (typeof window !== 'undefined') window.tracker = require('tracker');

var Tracking = {
  hasWindow: function hasWindow() {
    return typeof window !== 'undefined' && typeof window.tracker !== 'undefined' && typeof window.tracker.initialise !== 'undefined' && typeof window.tracker.page !== 'undefined' && typeof window.tracker.inline !== 'undefined' && typeof window.tracker.track !== 'undefined';
  },
  init: function init() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (this.hasWindow()) {
      var pageOptions = {
        page_type: 'landing'
      };
      if (params.agent && typeof params.agent === 'string') {
        pageOptions.agent = params.agent;
        if (!/(?:^| )agent=([^;]{3,6})/.test(document.cookie)) {
          // No agent cookie set already
          document.cookie = 'agent=' + params.agent; // Ensure the page's cookie matches the agent sent in the page tracking
        }
      }
      window.tracker.initialise({
        env: params.environment || process.env.NODE_ENV || 'production',
        service: params.service || 'seo',
        schemaVersions: params.schemaVersions || {}
      });
      if (params.pageOptions) pageOptions = Object.assign({}, pageOptions, params.pageOptions);
      window.tracker.page(params.eventType || 'landing', pageOptions);
      window.tracker.inline('auto_capture', { name: 'tech_platform', value: params.techPlatform || 'ssg' });
      if (params.templateGroup) window.tracker.inline('auto_capture', { name: 'template_group', value: params.templateGroup });
    } else console.log('No window, TRACKER NOT LOADED');
  },
  test: function test(data) {
    if (!this.hasWindow() || !data) return;
    window.tracker.track('test', data);
  },
  inline: function inline(type, name, value) {
    if (!this.hasWindow()) return;
    if (arguments.length === 2) {
      value = name;
      name = type;
      type = 'auto_capture';
    }
    window.tracker.inline(type, { name: name, value: value });
  },
  track: function track(name, value, type) {
    if (!this.hasWindow()) return;
    if (!type) {
      // We are doing an auto_capture as default which is now a window.tracker.inline
      // which autogenerates the page_action_id that we need
      return window.tracker.inline('auto_capture', { name: name, value: value });
    }
    if (type === 'test') {
      // We were meant to perform a split test event here so fire off to that instead
      if (!name) this.test(value);else this.test(name);
      return;
    }
    var dataAttributes = {
      action: {
        name: name,
        value: value
      }
    };
    if (!name) {
      dataAttributes = value;
    }
    // Ok we have the information now so lets track
    window.tracker.track(type, dataAttributes);
  }
};

module.exports = Tracking;